import React from 'react'
import Loader from 'react-loader-spinner'
import { withRouter } from 'react-router-dom'
import { Col, } from 'reactstrap'

import { pageHelpers } from ".."
import { disableJDOpsCenterIntegrationForTeam, environment, getIntegrationForTeam, loadExternalTeams } from "../../../api"
import { AdminLinkBubble, } from '../../ui'
import OrganizationSelector from '../../ui/OrganizationSelector'

import '../../../stylesheets/Teams.css'

class AuthCodeHandlerPage extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)
        pageHelpers.setupSingleRunAnimationEvents()
        const { token } = props

        let teamID = this.urlParams.team_id
        if (this.user && !teamID) {
            teamID = this.user.activeTeam
        }

        this.state = {
            loading: true,
            errors: [],
            teamID,
            token,
            integration: null,
            integrationID: null,
            externalTeams: [],
            selectedExternalTeam: null,
        }

        this.authorizeIntegration = this.authorizeIntegration.bind(this)
        this.handleOrganizationSubmit = this.handleOrganizationSubmit.bind(this)
    }

    async componentWillReceiveProps(nextProps) {
        pageHelpers.setupPropsForPage(nextProps, this)
    }

    async componentDidMount() {
        let { token, teamID, } = this.state;
        try {
            const integration = await getIntegrationForTeam(teamID, token);
            if (integration) {
                this.setState({
                    integration: integration,
                    integrationID: integration.id,
                });

                //If the integration already has an access token. This is basically called if the user refreshes 
                //when the dropdown menu is shown
                if (integration.has_access_token) {
                    this.setState({ externalTeams: await loadExternalTeams(integration.id, token) });
                }
                //Handle if the user hits the back arrow or ends up on this page with an existing integration
                if(integration.selected_external_team){
                    window.location.href = "/team?tab=3";
                }

                //Getting redirected to this page from Deere' site with a auth code in the url used in authorizeIntegration
                //to get the access token for the integration
                const urlParams = new URLSearchParams(window.location.search)
                const code = urlParams.get('code')
                console.log(integration.has_access_token, code)
                if (!integration.has_access_token && code) {
                    await this.authorizeIntegration(code, token)
                }
                else if(code){
                    //We want to do nothing here since this is the refreshing the page case
                }
                else{ //Denied Access to scopes
                    await disableJDOpsCenterIntegrationForTeam(teamID, token);
                    window.location.href = "/team?tab=3&error=User Denied Access to Organization";
                }
            }
            else{
                window.location.href = "/team?tab=3";
            }
        }
        catch (error) {
            console.error("Error: ", error)
            await disableJDOpsCenterIntegrationForTeam(teamID, token);
            window.location.href = "/team?tab=3";
        }
        this.setState({ loading: false });
    }

    async authorizeIntegration(code, token) {
        let { teamID } = this.state;
        let headers = new Headers();
        headers.append('Authorization', `Bearer ${token.accessToken}`);
        headers.append('Content-Type', 'application/json');

        const { integrationID } = this.state;

        try {
            let endpoint = `${environment.API_URL}/integrations/jdo/${integrationID}/authorize/`;
            let response = await fetch(endpoint, {
                method: 'PATCH',
                headers: headers,
                body: JSON.stringify({ authorization_code: code })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            let data = await response.json();

            // If a response from the server is received, handle the next step
            if (data && data.id) {
                this.setState({ externalTeams: await loadExternalTeams(data.id, token) });
            } else {
                console.error("Unexpected response received from the server.");
                await disableJDOpsCenterIntegrationForTeam(teamID, token);
                window.location.href = "/team?tab=3";
            }
        } catch (error) {
            console.error("A fetch error occurred: ", error);
            await disableJDOpsCenterIntegrationForTeam(teamID, token);
            window.location.href = "/team?tab=3";
        }
        finally {
        }
    }

    async handleOrganizationSubmit(selectedOrganizationID) {
        let { token, externalTeams, integrationID } = this.state;
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', `Bearer ${token.accessToken}`);
        let selectedOrganization = externalTeams.find(org => org.id === parseInt(selectedOrganizationID));
        console.log("Selected Organization: ", selectedOrganization);

        //update selected team inside integration
        try {
            let endpoint = `${environment.API_URL}/integrations/jdo/${integrationID}/`;
            let response = await fetch(endpoint, {
                method: 'PATCH',
                headers: headers,
                body: JSON.stringify({ selected_external_team: selectedOrganization.id })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            let data = await response.json();

            // If a response from the server is received, handle the next step on the next page
            if (data && data.id) {
                window.location.href = "/team/integrations/jdo/orgredirect"
            } else {
                console.error("Unexpected response received from the server.");
            }
        } catch (error) {
            console.error("A fetch error occurred: ", error);
        }
        if(!selectedOrganization){
            window.location.reload();
        }
        else if (!selectedOrganization.connected) {
            // Redirect to the organization's URL
            window.location.href = selectedOrganization.url;
        } else {
            // Update the selected_external_team in the integration
            window.location.href = "/team/integrations/jdo/orgredirect"
        }
    }

    render() {
        let {
            errors, teamID, loading, externalTeams
        } = this.state;

        return (loading ? <Loader type="TailSpin" color="orange" width={60} height={60} /> :
            <div className="m-0 p-0">
                <Col xs={12} className="justify-content-center p-0">

                </Col>
                {externalTeams.length > 0 &&
                    <OrganizationSelector
                        organizations={externalTeams}
                        onSubmit={this.handleOrganizationSubmit}
                    />
                }
                {teamID && this.user && this.user.isSupport ?
                    <AdminLinkBubble url={`marksman_api/team/${teamID}`} modelName="Team" className="mt-2" /> : null}

                {pageHelpers.renderErrorModalsForPage(errors, this)}
            </div>
        );
    }

}

export default withRouter(AuthCodeHandlerPage)



// WEBPACK FOOTER //
// ./src/components/pages/teams/AuthCodeHandlerPage.js